class KneePadsUpsell extends HTMLElement {
    connectedCallback() {
        const data = JSON.parse(this.getAttribute('data-upsell') || '{}');
        const { default: defaultItem, upsell } = data;

        this.defaultItem = defaultItem

        this.innerHTML = `
        <div class="knee-pads-container">
          <div class="included">
            <span>${defaultItem.title}</span>
          </div>
          <div class="upsell">
            <div class="left">
                ${upsell.image
                ? `<img src="${upsell.image}" alt="${upsell.title}" loading="lazy" width="100%" />`
                : ''
            }
            </div>
            <div class="content">
                <div class="top-content">
                    <p class="upgrade badge">${upsell.label}</p>

                    <div class="price">
                        <s>${upsell.original_price}</s>
                        <span class="discounted">$${upsell.discounted_price}</span>
                    </div>
                </div>
                <div class="title">${upsell.title}</div>
                <div class="bottom_content">
                    <div class="info">
                        <div class="desc">${upsell.description}</div>
                    </div>
                    <button class="add-btn">${upsell.button_text}</button>
                </div>

            </div>

          </div>
        </div>
      `;

        this.querySelector('.add-btn').addEventListener('click', () => {
            this.addToCart(upsell.id)
        });
    }

    async findCurrentVariantOnCart() {
        const cart = await fetch("/cart.js", {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });
        const cart_data = await cart.json();

        const currentVariant = cart_data.items.find(item => item.id === this.defaultItem.id);

        if (currentVariant) {
            return currentVariant;
        } else {
            return null;
        }
    }

    async addToCart(id) {

        const formReference = document.querySelector('variant-picker').getAttribute('form')
        const form = document.querySelector(`#${formReference}`)
        const currentId = form.elements["id"].value


        const items = [{
            id,
            quantity: 1,
        },
        {
            id: currentId,
            quantity: 1
        }];

        try {
            const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    items,
                    sections:
                        "cart-count, variant-added, sections--17218834694186__cart-drawer",
                }),
            });

            if (!response.ok) {
                throw new Error("Error al agregar productos al carrito");
            }

            const data = await response.json();
            const cart = await fetch("/cart.js", {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });
            const cart_data = await cart.json();

            document.dispatchEvent(
                new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                        baseEvent: "line-item:change",
                        cart: cart_data,
                    },
                })
            );

            document.documentElement.dispatchEvent(
                new CustomEvent("cart:refresh", {
                    bubbles: true,
                    detail: {
                        baseEvent: "variant:add",
                        cart: cart_data,
                    },
                })
            );

            document.querySelector('[aria-controls="cart-drawer"]').click();
            return data;
        } catch (error) {
            console.error("Error:", error);
        }
    }
}

customElements.define('knee-pads-upsell', KneePadsUpsell);